export default {
  patient: null,
  provider: null,
  uploadInfo: null,
  uploadURL: null,
  patientUploadURL: null
}



// WEBPACK FOOTER //
// ./src/store/modules/upload/state.js